'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation'; // Import useRouter for navigation
import { useTranslations } from 'next-intl';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('Error');
  const router = useRouter();
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-8">
      <p className="text-lg font-medium">{t('title')}</p>
      <button
        onClick={() => {
          // Redirect the user to /delete-session route
          router.push('delete-session');
        }}
        className="h-10 rounded-xl bg-primary px-4 font-medium text-on-primary group-invalid:bg-outline-variant group-invalid:text-outline"
      >
        {t('tryAgain')}
      </button>
    </div>
  );
}
